// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CampaignDaysPlay-module__dayGraph___CsWxi {
    aspect-ratio: 4/1;
    top: 0;
    left: 0;
    display: 'block';
}

@media (min-aspect-ratio: 2) {
    .CampaignDaysPlay-module__dayGraph___CsWxi {
        aspect-ratio: 5.5 / 1;
    }
}

.CampaignDaysPlay-module__chartShadow___y37xo {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
    height: fit-content;
    padding: 1rem;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: 'block';
}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/CampaignDaysPlay/CampaignDaysPlay.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,MAAM;IACN,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,sGAAsG;IACtG,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,gBAAgB;AACpB","sourcesContent":[".dayGraph {\n    aspect-ratio: 4/1;\n    top: 0;\n    left: 0;\n    display: 'block';\n}\n\n@media (min-aspect-ratio: 2) {\n    .dayGraph {\n        aspect-ratio: 5.5 / 1;\n    }\n}\n\n.chartShadow {\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n    height: fit-content;\n    padding: 1rem;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    display: 'block';\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dayGraph": `CampaignDaysPlay-module__dayGraph___CsWxi`,
	"chartShadow": `CampaignDaysPlay-module__chartShadow___y37xo`
};
export default ___CSS_LOADER_EXPORT___;
